import { FieldValidator as BaseFieldValidator } from "final-form"
import { validatePresence } from "./validatePresence"

export * from "./validatePresence"
export * from "./validateEmailFormat"
export * from "./validatePasswordFormat"
export * from "./validatePasswordConfirmation"
export * from "./validateDateOfBirth"
export * from "./validatePhoneNumber"
export * from "./validatePcn"
export * from "./validateBin"

export type FieldValidator = (...args: Parameters<BaseFieldValidator<any>>) => string | null

const chain = (functions: FieldValidator[]): FieldValidator => {
  const resultingValidator: FieldValidator = (...args) => {
    const validationResult = functions.map(f => f(...args))

    return validationResult.find(error => error !== null) || null
  }

  return resultingValidator
}

type ChainValidatorsFunction = (...functions: FieldValidator[]) => FieldValidator

/*
  @param validation functions needed for input
  The order of validations is defined by the order of the arguments.

  @returns { FieldValidator } returns a FieldValidator compatible with react-final-form validators
 */
export const chainValidators: ChainValidatorsFunction = (..._validators) => (value, _allValues, meta) =>
  chain(_validators)(value, _allValues, meta)

type GetValidatorFunction = (
  customValidation: FieldValidator | undefined,
  required: boolean | undefined
) => FieldValidator
export const getValidator: GetValidatorFunction = (customValidation = () => null, required) => {
  let validate: FieldValidator = customValidation

  if (required) {
    validate = chainValidators(validatePresence, validate)
  }

  return validate
}
